import { isBetweenInclusive } from '@dte/otw-utils-core/src/numbers/isBetween';

export function isValidLatitude(latitude: number | undefined | null): latitude is number {
	return isBetweenInclusive(latitude, -90, 90);
}

export function isValidLongitude(longitude: number | undefined | null): longitude is number {
	return isBetweenInclusive(longitude, -180, 180);
}
